import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { DollarSign, TrendingUp } from 'lucide-react';
import { fmtETDate } from '../../utils/tz';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Spending = () => {
  const [data, setData] = useState({ total_spent: 0, invoices: [] });

  useEffect(() => {
    fetchSpending();
  }, []);

  const fetchSpending = async () => {
    try {
      const { data } = await axios.get(`${API}/invoices/spending`, { withCredentials: true });
      setData(data);
    } catch (error) {
      console.error('Error fetching spending:', error);
    }
  };

  return (
    <div data-testid="spending-page" className="space-y-8">
      <div>
        <h2 className="font-['Outfit'] text-3xl font-bold text-white mb-2">Spending Summary</h2>
        <p className="text-[#A3A3A3]">Track your total spending with Nexflow</p>
      </div>

      <div className="bg-[#141414] border border-[#D4AF37] rounded-md p-8">
        <div className="flex items-center gap-4 mb-4">
          <div className="w-16 h-16 bg-[#D4AF37]/10 rounded-md flex items-center justify-center">
            <DollarSign className="w-8 h-8 text-[#D4AF37]" />
          </div>
          <div>
            <p className="text-[#A3A3A3] text-sm mb-1">Total Amount Spent</p>
            <p className="text-white text-4xl font-bold">${data.total_spent.toFixed(2)}</p>
          </div>
        </div>
      </div>

      <div>
        <h3 className="font-['Outfit'] text-xl font-bold text-white mb-4">Invoice History</h3>
        <div className="bg-[#141414] border border-[#262626] rounded-md overflow-hidden">
          <table className="w-full">
            <thead className="bg-[#0A0A0A] border-b border-[#262626]">
              <tr>
                <th className="text-left px-6 py-4 text-[#A3A3A3] text-sm font-medium">Invoice</th>
                <th className="text-left px-6 py-4 text-[#A3A3A3] text-sm font-medium">Description</th>
                <th className="text-left px-6 py-4 text-[#A3A3A3] text-sm font-medium">Date</th>
                <th className="text-right px-6 py-4 text-[#A3A3A3] text-sm font-medium">Amount</th>
              </tr>
            </thead>
            <tbody>
              {data.invoices.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center px-6 py-8 text-[#A3A3A3]">
                    No invoices yet
                  </td>
                </tr>
              ) : (
                data.invoices.map((invoice, idx) => (
                  <tr key={idx} className="border-b border-[#262626] last:border-0 hover:bg-[#0A0A0A] transition-colors">
                    <td className="px-6 py-4 text-white font-medium">{invoice.invoice_number}</td>
                    <td className="px-6 py-4 text-white">{invoice.description}</td>
                    <td className="px-6 py-4 text-[#A3A3A3]">
                      {fmtETDate(invoice.date)}
                    </td>
                    <td className="px-6 py-4 text-right text-[#D4AF37] font-bold">
                      ${invoice.amount.toFixed(2)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Spending;